import styled, { css } from 'styled-components';
import { Link } from 'gatsby';
import { underlineTransition } from '@components/link/link.styled';

interface StyledLinkProps {
  $isActive: boolean;
}

export const StyledLink = styled(Link)<StyledLinkProps>`
  ${({ theme, $isActive = false }) => css`
    ${underlineTransition}
    text-decoration: none;
    pointer-events: ${$isActive ? 'none' : 'auto'};
    font-family: ${theme.fontFamily.text};
    font-size: 1rem;
    font-weight: 500;
    color: ${theme.colors.black};

    @media only screen and (max-width: ${theme.breakpoints.lg}) {
      font-size: 1rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.lg}) {
      display: none;
    }
  `}
`;

export const StyledExternalLink = styled.a`
  ${({ theme }) => css`
    ${underlineTransition}
    text-decoration: none;
    font-family: ${theme.fontFamily.text};
    font-size: 1rem;
    font-weight: 500;
    color: ${theme.colors.black};

    @media only screen and (max-width: ${theme.breakpoints.lg}) {
      font-size: 1rem;
      display: none;
    }
  `}
`;

export const StyledBorderedLink = styled(StyledLink)`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    height: ${theme.inputSize.md.desktop.height};
    padding: 0 calc(${theme.inputSize.md.desktop.height} / 2);
    border-radius: calc(${theme.inputSize.md.desktop.height} / 2);
    border: ${theme.borderWidths.ui} solid ${theme.colors.primary};
    color: ${theme.colors.primary};
    background-color: transparent;
    font-weight: 500;
    font-family: ${theme.fontFamily.text};
    font-size: 1rem;
    background-image: none;

    :hover {
      background-color: ${theme.colors.primary};
      border-color: ${theme.colors.primary};
      color: ${theme.colors.white};
      text-decoration: none;
    }

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      height: ${theme.inputSize.sm.mobile.height};
      padding: 0 calc(${theme.inputSize.sm.mobile.height} / 2);
      border-radius: calc(${theme.inputSize.sm.mobile.height} / 2);
      font-size: ${theme.inputSize.sm.mobile.fontSize};
    }
  `}
`;

export const LinkContainer = styled.div`
  position: relative;
  margin-right: 1.25rem;
`;

export const LinkItem = styled.li`
  ${({ theme }) => css`
    ${StyledLink},
    ${StyledBorderedLink},
    ${StyledExternalLink} {
      color: ${theme.colors.black};
    }
  `}
`;
